import React from "react";
import PropTypes from "prop-types";
import { getPropsFromData, InputField, TextareaField } from "../../FormField";

const createDetailsRecord = (data, index) => (
  <tr>
    <td>
      <InputField {...getPropsFromData(data, `MoreInfoSubQNo${index}`)} />
    </td>
    <td>
      <InputField {...getPropsFromData(data, `MoreInfoName${index}`)} />
    </td>
    <td>
      <TextareaField cols={25} {...getPropsFromData(data, `MoreInfoDiagnosis${index}`)} />
    </td>
    <td>
      <InputField {...getPropsFromData(data, `MoreInfoFrom${index}`)} />
    </td>
    <td>
      <InputField {...getPropsFromData(data, `MoreInfoTo${index}`)} />
    </td>
    <td>
      <TextareaField cols={25} {...getPropsFromData(data, `MoreInfoMedicalProvider${index}`)} />
    </td>
  </tr>
);

const Details = ({ data }) => {
  return (
    <fieldset>
      <table className="hdf-form">
        <thead>
          <tr className="table-title">
            <th colSpan="6">
              F) If the answer to any questions in Section E is Yes, please provide FULL DETAILS.
              <br />
              <span style={{ fontWeight: "normal" }}>
                (If there is sufficient space below, kindly use a separate page and attach to this
                application form)
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr className="text-center">
            <td rowSpan="2" width="5%">
              Question Number
            </td>
            <td rowSpan="2" width="25%">
              Name of Person Concerned
              <br />
              (Employee/Spouse/Child(ren)
            </td>
            <td rowSpan="2" width="30%">
              Details of Diagnostic Test with reason & result /
              <br />
              Doctor’s Diagnosis / Injury / Treatment
            </td>
            <td colSpan="2" width="15%">
              Duration of Illness
            </td>
            <td rowSpan="2" width="25%">
              Name of Doctor Consulted &
              <br />
              Address of Clinic
            </td>
          </tr>
          <tr className="text-center">
            <td width="8%">From</td>
            <td width="7%">To</td>
          </tr>
          {createDetailsRecord(data, 1)}
          {createDetailsRecord(data, 2)}
          {createDetailsRecord(data, 3)}
          {createDetailsRecord(data, 4)}
          {createDetailsRecord(data, 5)}
          {createDetailsRecord(data, 6)}
        </tbody>
      </table>
    </fieldset>
  );
};

Details.propTypes = {
  data: PropTypes.object,
};

export default Details;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/RHI/RHIHD201907/Details.jsx